"use strict";
// Slim client entrypoint: region vocabulary + UI/lifecycle commands +
// wire creators, without the server engine. Client mods import this.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActions = exports.Overlay = exports.ClientUi = void 0;
// Side-effect: client region-class declaration-merge.
require("./src/clientRegions");
var models_1 = require("@creature-chess/models");
Object.defineProperty(exports, "ClientUi", { enumerable: true, get: function () { return models_1.ClientUi; } });
Object.defineProperty(exports, "Overlay", { enumerable: true, get: function () { return models_1.Overlay; } });
Object.defineProperty(exports, "PlayerActions", { enumerable: true, get: function () { return models_1.PlayerActions; } });
